import _ from 'lodash';
import * as Luxon from 'luxon';

window.NB_HOTKEY_LOG = +(window.localStorage.getItem('NB_HOTKEY_LOG') || 0);

export function getKeyState(e) {
  return {
    Alt: e.getModifierState('Alt'),
    AltGraph: e.getModifierState('AltGraph'),
    CapsLock: e.getModifierState('CapsLock'),
    Control: e.getModifierState('Control'),
    Fn: e.getModifierState('Fn'),
    Meta: e.getModifierState('Meta'),
    NumLock: e.getModifierState('NumLock'),
    OS: e.getModifierState('OS'),
    ScrollLock: e.getModifierState('ScrollLock'),
    Shift: e.getModifierState('Shift'),
    Symbol: e.getModifierState('Symbol'),
    key: e.key,
  }
}

export default function hotkey(combinations, options = { NumLock: false, CaseSensitive: false }) {
  let step = 0;
  const maxStep = combinations.length;
  const states = combinations.reduce((a, input) => {
    const state = {
      Alt: false,
      AltGraph: false,
      CapsLock: false,
      Control: false,
      Fn: false,
      Meta: false,
      NumLock: false,
      OS: false,
      ScrollLock: false,
      Shift: false,
      Symbol: false,
      key: null,
    };
    input.split('+').forEach(key => {
      switch (key) {
        case 'Alt':
          state.Alt = true;
          break;
        case 'AltGraph':
          state.AltGraph = true;
          break;
        case 'CapsLock':
          state.CapsLock = true;
          break;
        case 'Control':
          state.Control = true;
          break;
        case 'Fn':
          state.Fn = true;
          break;
        case 'Meta':
          state.Meta = true;
          break;
        case 'NumLock':
          state.NumLock = true;
          break;
        case 'OS':
          state.OS = true;
          break;
        case 'ScrollLock':
          state.ScrollLock = true;
          break;
        case 'Shift':
          state.Shift = true;
          break;
        case 'Symbol':
          state.Symbol = true;
          break;
        default:
          state.key = key;
          break;
      };
    });

    return [...a, state];
  }, []);
  return (e, handler) => {
    if (e.location !== 0) return;
    if (e.key === 'NumLock') return;
    const state = getKeyState(e);
    if (window.NB_HOTKEY_LOG) console.log(Luxon.DateTime.toFormat('HH:mm:ss.SSS'), 'HOTKEY', states, state, maxStep, step);
    if (!options.NumLock) {
      delete states[step].NumLock;
      delete state.NumLock;
    }

    const isEqual = options.CaseSensitive ? _.isEqual : (a, b) => _.isEqual(JSON.parse(JSON.stringify(a).toLowerCase()), JSON.parse(JSON.stringify(b).toLowerCase()));
    if (isEqual(states[step], state)) {
      ++step;
      if (step === maxStep) {
        step = 0;
        if (window.NB_HOTKEY_LOG) console.log(Luxon.DateTime.toFormat('HH:mm:ss.SSS'), 'HOTKEY.ACCEPT', states, state, maxStep, step);
        return handler && handler(e);
      }
    } else {
      if (window.NB_HOTKEY_LOG) console.log(Luxon.DateTime.toFormat('HH:mm:ss.SSS'), 'HOTKEY.REJECT', states, state, maxStep, step);
      step = 0;
    }
  };
}